import styled from "styled-components";

export const InvalidTokenWarningContainer = styled.div`
  width: 100%;
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;

  .card {
    background: ${({ theme }) => theme.colors.modalBackgroundColor};

    h1,
    h3 {
      color: ${({ theme }) => theme.colors.textColor};
    }
  }

  .card {
    width: 100%;
    display: flex;
    padding: 24px;
    max-width: 520px;
    border-radius: 18px;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    box-shadow: 1px 15px 30px rgba(0, 0, 0, 0.03);

    .buttons {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;

      button {
        margin-bottom: 8px;
        height: 40px;
        color: #1f1f1f;

        transition: 0.3s all;
      }

      .login {
        margin-left: 8px;
        width: 120px;
        span {
          color: #fff;
        }
      }

      .back-to-plataform span {
        color: #303030;
      }
    }
  }

  h1 {
    margin-top: 8px;
    margin-bottom: 24px;
  }

  h3,
  p {
    text-align: center;
    margin-bottom: 24px;
  }

  p {
    color: #999;
  }

  button {
    margin: 0;
  }

  @media screen and (max-width: 380px) {
    .ant-btn:not(:last-child) {
      margin: 0;
    }
  }
`;
